/* Signora Noir — background auto-merge.
   For each product image we sample its BORDER RING on a small downscaled canvas
   (a CORS-clean probe image; Shopify CDN sends Access-Control-Allow-Origin:* so
   the canvas never taints) and decide how to present it:

   • Uniform FLAT colour (pure black / near-black, navy, blue studio backdrop, etc.)
       - page surface (PDP): always remains true Noir black.
       - near-black neutral media floats seamlessly; coloured or visibly grey
         media gets the intentional frame instead of recolouring the whole page.
       - card on the fixed-black band/grid: float only when that colour is DARK;
         a non-black flat colour can't merge into a black band → gets framed.
   • Textured / busy background (leather, lifestyle, marble, a hand):
       - mark the frame .sjw-noir-framed → CSS gives an elegant matted frame
         (rounded + hairline border + shadow) instead of a raw rectangle.

   Fail-safe: if the pixels can't be read the element is left exactly as authored
   (seamless / black) — it never wrongly frames a good black-bg shot. */
(function () {
  function gp(d, w, x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2]]; }
  function med(a) { a = a.slice().sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }

  function sample(img) {
    try {
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh) return null;
      var w = 100, h = Math.max(8, Math.round(100 * nh / nw));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, w, h);
      var d = ctx.getImageData(0, 0, w, h).data, s = [], b = 2, i, j;
      for (i = b; i < w - b; i += 2) { s.push(gp(d, w, i, b)); s.push(gp(d, w, i, h - 1 - b)); }
      for (j = b; j < h - b; j += 3) { s.push(gp(d, w, b, j)); s.push(gp(d, w, w - 1 - b, j)); }
      if (s.length < 8) return null;
      var mr = med(s.map(function (p) { return p[0]; })),
          mg = med(s.map(function (p) { return p[1]; })),
          mb = med(s.map(function (p) { return p[2]; })), near = 0;
      s.forEach(function (p) {
        if (Math.abs(p[0] - mr) <= 24 && Math.abs(p[1] - mg) <= 24 && Math.abs(p[2] - mb) <= 24) near++;
      });
      return { r: mr, g: mg, b: mb, uniform: (near / s.length) >= 0.80 };
    } catch (e) { return null; }
  }

  function run(imgEl, frameEl, opts) {
    opts = opts || {};
    if (!imgEl) return;
    /* The Noir PDP shell is a fixed design surface, not a sampled media colour.
       Reset immediately so switching from video to image cannot leave behind a
       grey/blue page while the next poster probe is loading. */
    if (opts.page) document.documentElement.style.setProperty('--bg', '#000');
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var bg = sample(probe);
      if (!bg) return; // unreadable → leave as authored
      if (opts.page) {
        /* Only a neutral near-black edge is allowed to float without a frame.
           Dark navy and charcoal are still visibly different from true black,
           so colour spread is checked as well as the brightest channel. */
        var maxChannel = Math.max(bg.r, bg.g, bg.b);
        var minChannel = Math.min(bg.r, bg.g, bg.b);
        var noirBlack = maxChannel <= 28 && (maxChannel - minChannel) <= 12;
        if (bg.uniform && noirBlack) {
          if (frameEl) frameEl.classList.remove('sjw-noir-framed');
        } else {
          if (frameEl) frameEl.classList.add('sjw-noir-framed');
        }
      } else {
        var dark = Math.max(bg.r, bg.g, bg.b) < 46;
        if (bg.uniform && dark) {
          if (frameEl) frameEl.classList.remove('sjw-noir-framed');
        } else if (frameEl) {
          frameEl.classList.add('sjw-noir-framed');
        }
      }
    };
    probe.onerror = function () { /* leave as authored */ };
    probe.src = imgEl.currentSrc || imgEl.src;
  }

  window.SJWNoirBG = {
    run: run,
    scan: function (frameSel, imgSel, opts) {
      document.querySelectorAll(frameSel).forEach(function (f) {
        run(f.querySelector(imgSel || 'img'), f, opts || {});
      });
    }
  };
})();
